const URL =
  process.env.NODE_ENV === 'production'
    ? 'https://api.projecibul.com/'
    : 'https://api.projecibul.com/';
export default URL;
